module.exports = __webpack_public_path__ + "static/img/eqlogo.656e501.png";


//////////////////
// WEBPACK FOOTER
// ./src/eqvideo/imgs/eqlogo.png
// module id = vdYf
// module chunks = 1